module.exports = __webpack_public_path__ + "static/media/nav_dashboard.bdc39812.svg";